<template>
    <!-- 弹窗遮罩 -->
    <div class="lite_popup" v-show="show">
        <!-- 弹窗 -->
        <div class="lite_popup_box">
            <!-- 加载中 -->
            <div class="lite-version-loading" v-show="loadingVersions"></div>
            <!-- 标题栏 -->
            <div class="lite_popup_title">
                <!-- 标题 -->
                <span>{{ $t('language.cloudBackup.restore') }}</span>
                <!-- 关闭图标 -->
                <div class="icon white-close dialog-close" @click="close()"></div>
            </div>
            <!-- 内容 -->
            <div class="lite_popup_content">
                <!-- 选择版本 -->
                <div class="select-desc">{{$t('language.cloudBackup.selectVersions')}}</div>
                <el-select class="down_menu_items" popper-class="down_menu_item" size="small" v-model="version" placeholder=" ">
                    <el-option :label="formatDate(version)" :value="version+''" v-for="version in versions" :key="version"></el-option>
                </el-select>
                <span v-if="version" class="lite_backup_version_details" @click="loadVersionInfo(true)">
                    <span class="lite_backup_version_details_icon"></span>
                    <span>{{ $t('language.imageSaver.view') }}</span>
                </span>
                <!-- 换行 -->
                <br/>
                <!-- 同名处理 -->
                <div class="select-desc">{{$t('language.cloudBackup.restoreOptions')}}</div>
                <el-select class="down_menu_items" popper-class="down_menu_item" size="small" v-model="sameName" placeholder=" ">
                    <el-option :label="$t('language.cloudBackup.keepLatest')" value=""></el-option>
                    <el-option :label="$t('language.popup.overWrite')" value="overwrite"></el-option>
                    <el-option :label="$t('language.popup.skipFile')" value="skip"></el-option>
                    <el-option :label="$t('language.popup.rename')" value="rename"></el-option>
                </el-select>
                <!-- 还原位置选择：原位置 -->
                <el-radio-group v-model="restoreLocation" class="restore-location">
                    <el-radio label="old">{{ $t('language.cloudBackup.restoreOriginal') }}</el-radio>
                </el-radio-group>
                <!-- 展示原目的地 -->
                <div v-if="data" class="restore_tree_box myscroll">
                    <el-tree :data="convertData()" class="restore_tree" :default-expand-all="true">
                       <span class="custom-tree-node2" slot-scope="{ node, data }">
                            <span v-if="node.level == 1" :class="'drive-icon2 drive-icon-' + data.icon">{{ data.label }}</span>
                            <span v-else>
                                <img class="node-icon2" :src="'/static/file/' + data.icon + '.svg'" @error="e => e.target.src = '/static/file/file.svg'" />
                                <span class="node-name-label2">{{ data.label }}</span>
                            </span>
                        </span>
                    </el-tree>
                </div>
                <!-- 还原位置选择：新位置 -->
                <el-radio-group v-model="restoreLocation" class="restore-location">
                    <el-radio label="new">{{ $t('language.cloudBackup.restoreNewLocation') }}</el-radio>
                </el-radio-group>
                <!-- 展示已选择的目的地 -->
                <div v-if="newLocationDid" class="restore_tree_box myscroll">
                    <el-tree :data="convertSelect()" class="restore_tree" :default-expand-all="true">
                       <span class="custom-tree-node2" slot-scope="{ node, data }">
                            <span v-if="node.level == 1" :class="'drive-icon2 drive-icon-' + data.icon">{{ data.label }}</span>
                            <span v-else>
                                <img class="node-icon2" :src="'/static/file/' + data.icon + '.svg'" @error="e => e.target.src = '/static/file/file.svg'" />
                                <span class="node-name-label2">{{ data.label }}</span>
                            </span>
                        </span>
                    </el-tree>
                </div>
                <!-- 展示已选择的目的地（成对选择的） -->
                <div v-if="restoreSelect.froms.length>0 && restoreSelect.tos.length>0" class="restore_select_list_box">
                    <div class="restore_select_edit" @click="selectTaskTo()"></div>
                    <div class="restore_select_row">
                        <div class="restore_select_left head">{{ $t('language.website.sourceServers') }}</div>
                        <div class="restore_select_right head">{{ $t('language.website.targetServers') }}</div>
                    </div>
                    <div class="restore_select_row myscroll">
                        <div class="restore_select_left">
                            <div class="restore_select_item" v-for="item in restoreSelect.froms">
                                <div class="restore_select_item_icon" :class="item.node.type"></div>
                                <div class="restore_select_item_text">{{ item.node.name }}</div>
                                <div class="restore_select_item_bg"></div>
                            </div>
                        </div>
                        <div class="restore_select_right">
                            <div class="restore_select_item" v-for="item in restoreSelect.tos">
                                <div class="restore_select_item_icon" :class="item.node.type"></div>
                                <div class="restore_select_item_text">{{ item.node.name }}</div>
                                <div class="restore_select_item_bg"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 底部 -->
             <div class="lite_popup_footer">
                <!-- 按钮 -->
                <button @click="close()" class="white">{{ $t('language.common.cancel') }}</button>
                <button v-if="version && restoreLocation=='new' && !newLocationDid && restoreSelect.froms.length==0" @click="selectTaskTo()">{{ $t('language.common.setUp') }}</button>
                <button v-if="version && (restoreLocation=='old' || (restoreLocation=='new'&&(newLocationDid||restoreSelect.froms.length>0)))" @click="ok()">{{ $t('language.cloudBackup.restore') }}</button>
            </div>
            <!-- 备份任务还原目标选择 -->
            <liteSelect ref="taskToTree" :showCheckbox="false" :showDBDrive="false" :showFileNode="false" :showNewFolder="true" @selectDone="selectDoneTo" />
            <!-- 网站备份任务还原目标选择 -->
            <liteSelect ref="taskToTreeWebsite" :onlyWebsite="true" :showWebsite="true" :showCheckbox="false" :showDBDrive="false" :showFileNode="false" :showNewFolder="true" @selectDone="selectDoneTo" />
            <!-- 已备份某版本文件列表 -->
            <liteBackupFiles ref="backupFiles" :files="versionFiles" />
            <!-- 网站备份还原选择 -->
            <liteWebsiteRestoreSelect ref="websiteRestoreSelect" :data="restoreParam" :versionFiles="versionFiles" @ok="websiteRestoreSelectDone" />
            <!-- 覆盖警告 -->
            <liteConfirmMysql ref="liteConfirmMysql" @ok="mysqlOK" @cancel="mysqlCancel" />
        </div>
    </div>
</template>

<script>
import liteConfirmMysql from "@/components/workspace/lite_confirm_mysql";
import liteWebsiteRestoreSelect from "@/components/workspace/lite_website_restore_select";
import liteBackupFiles from "@/components/workspace/lite_backup_files";
import liteSelect from "@/components/workspace/lite_select";
import commonUtils from "@/js/workspace/common_util.js";
import requestUtils from '@/js/request_util.js';
import { Message } from "element-ui";

export default {
    props: {
        data: Object,
    },
    components: {
        liteSelect,
        liteBackupFiles,
        liteWebsiteRestoreSelect,
        liteConfirmMysql,
    },
    computed: {
        restoreParam() {
            return {
                task: this.data,
                version: this.version,
            };
        },
    },
    watch: {
        version: function (val) {
            this.restoreSelect.froms = [];
            this.restoreSelect.tos = [];
            if (val) {
                this.loadVersionInfo(false);
            }
        },
        sameName: function (val) {
            // 网站备份任务的还原
            if (this.data.type == 'website') {
                // 选择覆盖选项，就弹窗提示
                if (val == 'overwrite') {
                    this.$refs.liteConfirmMysql.show = true;
                }
            }
        },
    },
    data() {
        return {
            // 是否显示弹窗
            show: false,
            // 是否正在加载版本
            loadingVersions: false,
            // 同名处理
            sameName: '',
            // 所有版本
            versions: [],
            // 已选择版本
            version: '',
            // 新旧位置标识
            restoreLocation: 'old',
            // 新位置云盘ID
            newLocationDid: '',
            // 新位置节点
            newLocationNode: null,
            // 创建任务参数
            taskParam: null,
            // 创建任务中
            createTasking: false,
            // 版本具体文件信息
            versionFiles: [],
            // 还原已选择的成对节点
            restoreSelect: {
                froms: [],
                tos: [],
            },
            // 已备份的数据库或站点（已备份文件里面分析出来的）
            dbSites: [],
            // 原数据库或站点（源网站云盘里面分析出来的）
            originDbSites: [],
            // 拼凑的数据
            combineData: [],
            // 是否使用拼凑的数据
            useCombineData: false,
        };
    },
    methods: {
        mysqlOK() {

        },
        mysqlCancel() {
            this.sameName = '';
        },
        websiteRestoreSelectDone(froms, tos) {
            this.restoreSelect.froms = froms;
            this.restoreSelect.tos = tos;
        },
        // 解析节点图标
        getNodeIcon(node) {
            if (node.dir) {
                if (node.type == "site") {
                    // 站点
                    return "site";
                } else if (node.type == "db") {
                    // 数据库
                    return "db";
                } else {
                    // 文件夹或相簿
                    return "folder";
                }
            } else {
                const index = node.name.lastIndexOf(".");
                if (index == -1) {
                    // 没有后缀的文件
                    return "file";
                } else {
                    const suffix = node.name.substring(index + 1).toLowerCase();
                    if (suffix.length == 0) {
                        // 包含点，但是没有后缀
                        return "file";
                    } else {
                        // 返回文件后缀，不一定靠谱
                        return suffix;
                    }
                }
            }
        },
        // 原位置节点转为树显示
        convertData() {
            if (this.useCombineData) {
                let drive = this.getDrive(this.data.fdid);
                let treeNode = {label:drive.name,isLeaf:false,children:[],icon:drive.type};
                for(let i=0; i<this.combineData.length; i++) {
                    let node = this.combineData[i];
                    let subNode = {label:node.name,isLeaf:false,children:[],icon:node.type};
                    treeNode.children.push(subNode);
                }
                return [treeNode];
            } else {
                return this.convert(this.data.fdid, this.data.param.from);
            }
        },
        // 已选择的节点转为树显示
        convertSelect() {
            return this.convert(this.newLocationDid, this.newLocationNode);
        },
        convert(did, nodeParam) {
            let rootNode = null;
            let lastNode = null;
            let arr = this.getNodeArr(nodeParam);
            for (let i = 0; i < arr.length; i++) {
                let curNode = {label: arr[i].name,isLeaf:false,children:[],icon:this.getNodeIcon(arr[i])};
                if (rootNode == null) {
                    rootNode = curNode;
                } else {
                    lastNode.children.push(curNode);
                }
                lastNode = curNode;
            }
            let drive = this.getDrive(did);
            let treeNode = {label:drive.name,isLeaf:false,children:[],icon:drive.type};
            if (rootNode != null) {
                treeNode.children.push(rootNode);
            }
            return [treeNode];
        },
        // 选择任务目标
        selectTaskTo() {
            if (this.data.type == "backup") {
                // 备份任务还原，选择文件夹
                this.$refs.taskToTree.show = true;
            } else if (this.data.type == "website") {
                if (this.data.param.from) {
                    // 网站备份任务还原，选择文件夹。源是：普通文件、sql文件、文件夹、站点、数据库
                    this.$refs.taskToTreeWebsite.show = true;
                    let type = this.data.param.from.type;
                    if (type == 'file' || type == 'folder') {
                        // 普通文件、文件夹
                        this.$refs.taskToTreeWebsite.selectType = 'dir';
                        if (this.data.param.from.parent.type == 'db') {
                            // sql文件
                            this.$refs.taskToTreeWebsite.selectType = 'db';
                        }
                    } else {
                        // 站点、数据库
                        this.$refs.taskToTreeWebsite.selectType = type;
                    }
                } else {
                    // 网站备份任务还原，选择多样化处理。源是整个网站
                    this.$refs.websiteRestoreSelect.show = true;
                    this.$refs.websiteRestoreSelect.init();
                }
            }
        },
        // 任务目标选择完成
        selectDoneTo(data) {
            // 选择结果赋值
            this.newLocationDid = data.did;
            this.newLocationNode = data.node;
        },
        // 获取节点路径
        getNodePath(node) {
            let path = '';
            let arr = this.getNodeArr(node);
            for (let i = 0; i < arr.length; i++) {
                let item = arr[i];
                path += '/' + item.name;
            }
            return path;
        },
        // 获取节点和父
        getNodeArr(node) {
            let arr = [];
            while (node) {
                arr.push(node);
                node = node.parent;
            }
            return arr.reverse();
        },
        // 获取云盘
        getDrive(id) {
            for (let i = 0; i < this.$store.state.drives.length; i++) {
                let drive = this.$store.state.drives[i];
                if (drive.id === id) {
                    return drive;
                }
            }
            return null;
        },
        // 格式化时间
        formatDate(value) {
            if (!value) return '';
            const date = new Date(value);
            if (isNaN(date.getTime())) return '';
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        async ok() {
            let paramTo;
            if (this.restoreLocation == 'old') {
                paramTo = this.data.param.from;
                if (paramTo && !paramTo.dir) {
                    paramTo = paramTo.parent;
                }
            } else {
                paramTo = this.newLocationNode;
            }
            // 创建任务参数
            this.taskParam = {
                type: 'restore',
                name: this.data.name + ' Restore ' + this.formatDate(parseInt(this.version)) + ' to ' + this.restoreLocation,
                fdid: this.data.tdid,
                tdid: (this.restoreLocation=='old' ? this.data.fdid : this.newLocationDid),
                param: {
                    from: this.data.param.to,
                    to: paramTo,
                    options: {
                        listThread: commonUtils.getUser().vip ? 3 : 1,
                        runThread: commonUtils.getUser().vip ? 10 : 2,
                        email: '',
                        cron: '',
                        sameName: this.sameName,
                        excludeNames: [],
                        allowedExtensions: [],
                        type: 'restore',
                        onlyAdd: false,
                        schedules: {disabled:true},
                        delete: false,
                        keepDate: false,
                        logFile: false,
                        inOneFolder: false,
                        syncMode: '',
                        version: this.data.id + '-' + this.version,
                    }
                }
            }
            await this.createTask();
            this.close();
            this.$emit('ok');
        },
        // 创建任务
        createTask(callback) {
            if (this.createTasking) return;
            // 未设置任务名称
            if (!this.taskParam.name) {
                Message.error("Please input task name");
                return;
            }
            if (this.restoreLocation=='new' && this.restoreSelect.froms.length>0) {
                this.taskParam.param.options.type = this.taskParam.type;
                // 网站备份成对还原
                const taskParam = {
                    type: this.taskParam.type,
                    name: this.taskParam.name,
                    param: {
                        froms: this.restoreSelect.froms,
                        tos: this.restoreSelect.tos,
                        options: this.taskParam.param.options,
                    }
                }
                // 开始创建任务
                return new Promise((resolve, reject) => {
                    this.createTasking = true;
                    this.sendRequest("/task/create", taskParam, () => {
                        this.createTasking = false;
                        if (callback) {
                            callback();
                        } else {
                            Message.success("Task created successfully");
                            this.listTasks();
                        }
                        resolve();
                    });
                });
            } else {
                // 备份还原或网站备份还原
                // 未选择源
                if (!this.taskParam.fdid) {
                    Message.error("Please select source cloud");
                    return;
                }
                // 未选择目标
                if (!this.taskParam.tdid) {
                    Message.error("Please select destination cloud");
                    return;
                }
                // 目标只能是文件夹
                let to = this.taskParam.param.to;
                if (to && !to.dir) {
                    Message.error("Task targets can only be folders");
                    return;
                }
                // 快捷创建任务：设置类型与任务类型匹配
                this.taskParam.param.options.type = this.taskParam.type;
                // 开始创建任务
                return new Promise((resolve, reject) => {
                    this.createTasking = true;
                    this.sendRequest("/task/create", this.taskParam, () => {
                        this.createTasking = false;
                        if (callback) {
                            callback();
                        } else {
                            Message.success("Task created successfully");
                            this.listTasks();
                        }
                        resolve();
                    });
                });
            }
        },
        // 获取任务列表
        listTasks(callback) {
            this.sendRequest("/task/list", {}, (data) => {
                this.$store.state.tasks = data;
                if (callback) callback();
            })
        },
        clearPageChoose() {
            // 有用，不能删除
        },
        init() {
            // 初始化数据
            this.version = '';
            this.versions = [];
            this.sameName = '';
            this.restoreLocation = 'old';
            this.newLocationDid = '';
            this.newLocationNode = null;
            this.show = true;
            // 获取版本列表
            this.loadingVersions = true;
            this.sendRequest('/task/restoreVersions', { id: this.data.id }, (res) => {
                this.versions = res;
                this.loadingVersions = false;
                if (res.length > 0) {
                    this.version = res[0] + '';
                }
            }, () => {
                this.loadingVersions = false;
            });
        },
        loadVersionInfo(show) {
            if (show) {
                if (this.versionFiles.length > 0) {
                    this.$refs.backupFiles.show = true;
                } else {
                    Message.warning("No files found in this version");
                }
            } else {
                this.loadingVersions = true;
                this.sendRequest('/task/versionInfo', { id: this.data.id, version: this.version }, (res) => {
                    this.versionFiles = res;
                    if (!this.data.param.from && this.getDrive(this.data.fdid).type=='Website') {
                        // 当备份整个网站时，还原到原始位置处的树没有子节点，需要拼凑出来
                        // 从已备份文件里面解析信息
                        this.dbSites = [];
                        const prefix = this.getNodePath(this.data.param.to);
                        const start = prefix.length + 1;
                        for (var i = 0; i < this.versionFiles.length; i++) {
                            const pathSub = this.versionFiles[i].path.substring(start);
                            const name = pathSub.substring(0, pathSub.indexOf('/'));
                            if (this.dbSites.indexOf(name) == -1) {
                                this.dbSites.push(name);
                            }
                        }
                        // 展开源里面的数据
                        this.originDbSites = [];
                        this.sendRequest("/file/list", { id: this.data.fdid, param: { node: null, start: null } }, (res) => {
                            let nodes = res.nodes;
                            for (var i=0; i<nodes.length; i++) {
                                let node = nodes[i];
                                this.originDbSites.push({ name: node.name.replace(/:/g, '_'), type: node.type })
                            }
                            // 展开目标里面的数据
                            this.sendRequest("/file/list", { id: this.data.tdid, param: { node: this.data.param.to, start: null } }, (res2) => {
                                let toNodes = res2.nodes;
                                // 之前备份过的，重新把类型确定回来
                                toNodes.forEach(node => {
                                    if (node.dir) {
                                        for (let i = 0; i < this.originDbSites.length; i++) {
                                            if (this.originDbSites[i].name == node.name) {
                                                node.type = this.originDbSites[i].type;
                                                break;
                                            }
                                        }
                                    }
                                });
                                // 只展示之前备份过的
                                let filterData = [];
                                for(var i=0;i<toNodes.length;i++) {
                                    if (this.dbSites.indexOf(toNodes[i].name) != -1) {
                                        filterData.push(toNodes[i]);
                                    }
                                }
                                // 站点排在数据库前面，然后名称升序
                                filterData.sort(function (a, b) {
                                    let typeRes = a.type.localeCompare(b.type);
                                    if (typeRes == 0) {
                                        return a.name.localeCompare(b.name);
                                    } else {
                                        return -typeRes;
                                    }
                                });
                                this.combineData = filterData;
                                this.useCombineData = true;
                                // 处理完成
                                this.loadingVersions = false;
                            });
                        });
                    } else {
                        // 其他根据任务源参数正常显示
                        this.useCombineData = false;
                        this.loadingVersions = false;
                    }
                }, () => {
                    this.loadingVersions = false;
                });
            }
        },
        close() {
            this.show = false;
        },
        // 发送Lite请求
        sendRequest(path, data, callback, errCallback) {
            requestUtils.doLiteRequest(path, data)
                .then(res => {
                    let code = res.code
                    let msg = res.msg
                    if (msg == undefined) {
                        msg = res.message;
                    }
                    if (code == 200) {
                        // 请求成功
                        if (callback) {
                            callback(res.data);
                        }
                    } else if (code == 400) {
                        // 请求失败
                        Message.warning(msg);
                        if (errCallback) {
                            errCallback()
                        }
                    } else {
                        if (msg == "Unauthorized") {
                            // 未登录
                            location.href = location.host.includes("localhost") ? "http://localhost:8080/share/123" : "https://" + location.host + "/sign"
                        } else {
                            // 服务器异常
                            Message.error(msg);
                            if (errCallback) {
                                errCallback()
                            }
                        }
                    }
                }, err => {
                    // 请求异常
                    Message.error(err);
                    if (errCallback) {
                        errCallback()
                    }
                });
        }
    }
};
</script>

<style>
/* 弹窗宽度 */
.lite_popup_box {
    width: 600px;
}
/* 还原位置选择 */
.restore-location {
    margin-top: 40px;
}
.restore-location>.el-radio {
    display: block;
    margin-top: 0px;
}
.restore-location .el-radio__input.is-checked+.el-radio__label {
    color: #333333;
    font-weight: bold;
}
/* 下拉菜单描述 */
.select-desc {
    color: #606266;
    display: inline-block;
    margin-right: 10px;
    min-width: 150px;
}
/* 让loading在内部显示 */
.lite_popup_content {
    position: relative;
}
/* 加载备份版本信息 */
.lite-version-loading {
    position: absolute;
    z-index: 1;
    left: 0;
    top: 40px;
    width: 100%;
    height: calc(100% - 40px);
    background: rgba(255, 255, 255, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}
.lite-version-loading::after {
    content: "";
    width: 48px;
    height: 48px;
    border: 4px solid #DCE4F5;
    border-top-color: #5562B4;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}
@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}
/* 显示版本信息 */
.lite_backup_version_details {
    margin-left: 20px;
    cursor: pointer;
    color: #5562B4;
}
.lite_backup_version_details:hover {
    text-decoration: underline;
}
.lite_backup_version_details_icon {
    background-image: url("../../assets/images/vectorImg/icon_Preview.svg");
    width: 16px;
    height: 16px;
    display: inline-block;
    position: relative;
    top: 2px;
}
/* 下拉菜单 */
.down_menu_items {
    width: 300px;
}
.down_menu_items .el-input__suffix {
    height: 32px;
    top: 10px;
}
.down_menu_item .el-select-dropdown__item {
    color: #6f7886;
    font-size: 12px;
}
.down_menu_item .el-select-dropdown__item.selected {
    color: #6f7886;
}

/* 树的节点布局 */
.custom-tree-node2 {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
}

/* 云盘图标 */
.drive-icon2 {
    width: 24px;
    height: 24px;
    line-height: 24px;
    text-indent: 35px;
    background-size: 100%;
}

/* 网站图片太大，特殊处理 */
.custom-tree-node2>.drive-icon-Website {
    width: 22px;
    height: 22px;
}

/* 文件夹文件图标 */
.node-icon2 {
    width: 24px;
    height: 24px;
    margin-right: 4px;
}

/* 节点名称 */
.node-name-label2 {
    vertical-align: middle;
    max-width: 340px;
    overflow: hidden;
    display: inline-block;
    text-overflow: ellipsis;
}

.restore_tree .el-tree-node__content {
    height: 30px !important;
}

.restore_tree_box {
    max-height: 125px;
    overflow: auto;
    position: relative;
    margin-top: 10px;
    background: #F9FBFE;
    padding: 10px;
}

.restore_tree {
    background: transparent;
}

.restore_select_list_box {
    border: 1px solid #cfdaf2;
    margin-top: 10px;
    border-radius: 8px;
    position: relative;
}

.restore_select_row {
    display: flex;
}

.restore_select_row.myscroll {
    overflow: auto;
    max-height: 160px;
}

.restore_select_left,
.restore_select_right {
    flex: 1;
}

.restore_select_left.head,
.restore_select_right.head {
    font-size: 18px;
    height: 40px;
    line-height: 40px;
    background: #F9FBFE;
    color: #9DA8D3;
    text-indent: 10px;
    border-radius: 8px;
    font-weight: bold;
    font-size: 14px;
}

.restore_select_item {
    height: 40px;
    position: relative;
}

.restore_select_item_icon {
    width: 24px;
    height: 24px;
    display: inline-block;
    vertical-align: middle;
    margin-left: 10px;
    margin-right: 5px;
    background-size: 24px;
    background-position: center;
    background-repeat: no-repeat;
}
.restore_select_item_icon.site {
    background-image: url("../../assets/images/lite/icon/site.svg");
}
.restore_select_item_icon.db {
    background-image: url("../../assets/images/lite/icon/db.svg");
}
.restore_select_item_icon.folder {
    background-image: url("../../assets/images/lite/icon/folder.svg");
}

.restore_select_item_text {
    display: inline-block;
    vertical-align: middle;
    color: #606266;
    width: calc(100% - 50px);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    height: 40px;
    line-height: 40px;
}
.restore_select_left .restore_select_item_bg {
    width: 200%;
    height: 100%;
    background: rgba(0, 106, 255, 0.05);
    position: absolute;
    top: 0;
    display: none;
}
.restore_select_right .restore_select_item_bg {
    width: 200%;
    height: 100%;
    background: rgba(0, 106, 255, 0.05);
    position: absolute;
    top: 0;
    right: 0;
    display: none;
}
.restore_select_item:hover .restore_select_item_bg {
    display: block;
}
.restore_select_edit {
    background-image: url("../../assets/images/lite/icon/pen.svg");
    width: 16px;
    height: 16px;
    position: absolute;
    z-index: 1;
    right: 16px;
    top: 10px;
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/workspace/lite_restore.vue